export const selectSalaryStructures = (state) =>
  state.companySalaryStructure?.salaryStructures || [];
export const selectSalaryStructureLoading = (state) =>
  state.companySalaryStructure?.loading || false;
export const selectSalaryStructureError = (state) =>
  state.companySalaryStructure?.error || null;
export const selectSelectedSalaryStructure = (state) =>
  state.companySalaryStructure?.selectedSalaryStructure || null;
export const selectSalaryStructurePagination = (state) =>
  state.companySalaryStructure?.pagination || {};
